import PageHeaderSimple from './PageHeaderSimple'

export default PageHeaderSimple
